const colors = {
  brand: {
    primary: '#0aa',
    secondary: '#aca',
  },
}

export default colors
